import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import GuestStatus from './components/GuestStatus';
import BookPage from './components/BookPage';
import reportWebVitals from './reportWebVitals';

// Standalone destinations that skip the guide's chrome:
//   /status — check-in/out page (QR code at the property)
//   /book   — direct-booking request, linked only from the next-stay offer email
const path = window.location.pathname.replace(/\/+$/, '') || '/';
const Page = path === '/status' ? GuestStatus : path === '/book' ? BookPage : App;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Page />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
